// removed by extract-text-webpack-plugin
module.exports = {"miniStory":"style__miniStory__3of25","selected":"style__selected__3JZO7","mainContainer":"style__mainContainer__1Wlq9","miniStoriesContainer":"style__miniStoriesContainer__2DbWN","spacer":"style__spacer__1_9gF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/story_details/miniStories/style.scss
// module id = 731
// module chunks = 0